module.exports = __webpack_public_path__ + "img/sewing.b5bf3f8b.svg";